import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../config/routes';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleVolverInicio = () => {
    navigate(routes.home);
  };

  const handleVolverProductos = () => {
    navigate(routes.productos);
  };

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1 className="not-found-title">Página no encontrada</h1>
        <p className="not-found-description">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        <div className="not-found-actions">
          <button 
            className="btn-primary" 
            onClick={handleVolverInicio}
          >
            Volver al Inicio
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleVolverProductos}
          >
            Ver Productos
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 